import React from "react";
import { BrowserRouter as Router, Routes, Route, Outlet } from "react-router-dom";
import { Provider } from "react-redux";
import store from "./redux/store";
import Sidebar from "./components/ui/Sidebar";
import GlobalOverlays from "./components/ui/GlobalOverlays";
import RequiresLogin from "./components/RequiresLogin";
import Suppliers from "./routes/Suppliers";
import DailyReports from "./routes/DailyReports";
import DailyReportForm from "./routes/DailyReportForm";
import PeriodReports from "./routes/PeriodReports";
import Promitheies from "./routes/Promitheies";
import NotFound from "./routes/NotFound";
import HomePage from "./routes/HomePage";
import PromitheiaForm from "./components/promitheies/PromitheiaForm";
import Login from "./routes/Login";
import ChangePin from "./routes/ChangePin";

// Shell for every authenticated screen: sticky header + a fixed-height content
// area. Each screen manages its own scrolling so forms can pin footers.
const ProtectedLayout = () => (
  <RequiresLogin>
    <div className="flex h-full flex-col">
      <Sidebar />
      <main className="relative flex flex-1 flex-col overflow-hidden">
        <Outlet />
      </main>
    </div>
  </RequiresLogin>
);

function App() {
  return (
    <Provider store={store}>
      <Router>
        <GlobalOverlays />
        <Routes>
          {/* Public */}
          <Route path="/login" element={<Login />} />

          {/* Protected */}
          <Route element={<ProtectedLayout />}>
            <Route path="/" element={<HomePage />} />
            <Route path="/change-pin" element={<ChangePin />} />
            <Route path="/suppliers" element={<Suppliers />} />
            <Route path="/daily-reports" element={<DailyReports />} />
            <Route path="/daily-reports/new" element={<DailyReportForm />} />
            <Route path="/daily-reports/:key" element={<DailyReportForm />} />
            <Route path="/period-report" element={<PeriodReports />} />
            <Route path="/ekkathariseis" element={<Promitheies />} />
            <Route path="/ekkathariseis/:fDate/:key" element={<PromitheiaForm />} />
            <Route path="/ekkathariseis/new" element={<PromitheiaForm />} />
            <Route path="*" element={<NotFound />} />
          </Route>
        </Routes>
      </Router>
    </Provider>
  );
}

export default App;
